import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const MobileWalletHistory = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(0);
  };
  const transactions = [
    { description: 'Promotional Reward Added on Registration', amount: '₹500.00', positive: true },
    { description: 'Hanif (Referral)', amount: '₹200.00', positive: true },
    { description: 'Active 5g (Refund)', amount: '₹200.00', positive: true },
    { description: 'Ikhlas (Referral)', amount: '₹200.00', positive: true },
    { description: 'Top Up', amount: '₹200.00', positive: true },
    { description: 'Pulsar150 (Refund)', amount: '₹200.00', positive: false },
    { description: 'Ikhlas (Referral)', amount: '₹200.00', positive: true },
    { description: 'Mallik (Referral)', amount: '₹200.00', positive: true },
    { description: 'Harley', amount: '₹200.00', positive: false },
    { description: 'Ikhlas (Referral)', amount: '₹200.00', positive: true },
  ];

  return (
    <>
      <div className="w-full bg-[#FF9630] text-white py-4 px-6 flex items-center">
        <button onClick={handleBack} className="mr-4 text-white hover:text-gray-200">
          <FaArrowLeft className="text-lg" />
        </button>
        <h1 className="text-xl font-semibold">Wallet History</h1>
      </div>
      <div className="w-full mx-auto p-4 bg-white rounded-lg ">
        <div className="space-y-4 ">
          {transactions.map((transaction, index) => (
            <div
              key={index}
              className="flex justify-between items-center p-3 border border-gray-200 rounded-lg"
            >
              <p className="text-[#FF9630] text-sm">{transaction.description}</p>
              <p
                className={`text-sm font-semibold ${transaction.positive ? 'text-green-600' : 'text-red-500'
                  }`}
              >
                {transaction.amount}
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default MobileWalletHistory;
